<script setup lang="ts">
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import { WithButtonProps } from "./banner.interfaces";
import { computed, ref } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import Background from "./shared/background/Background.vue";
import DismissButton from "./shared/dismiss-button/DismissButton.vue";
import Button from "./shared/button/Button.vue";
import Title from "./shared/title/Title.vue";
import Description from "./shared/description/Description.vue";

const props = defineProps<{
    block: PageBlock<WithButtonProps>;
    pageColors: CssVarColors;
}>();

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const isVisible = ref(true);
</script>

<template>
    <Background v-if="isVisible" :is-with-effect="true" :background-color="styleValues.background">
        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
            <p class="text-sm/6">
                <EditableElement
                    v-if="!dataValues.title.isHidden"
                    :blockId="block.id"
                    field-name="title"
                >
                    <Title
                        :text="dataValues.title.data.text"
                        :textColor="styleValues.text"
                        :showDot="!dataValues.description.isHidden"
                    />
                </EditableElement>
                <EditableElement
                    v-if="!dataValues.description.isHidden"
                    :blockId="block.id"
                    field-name="description"
                >
                    <Description
                        :text="dataValues.description.data.text"
                        :textColor="styleValues.text"
                    />
                </EditableElement>
            </p>
            <EditableElement
                v-if="!dataValues.button.isHidden"
                :blockId="block.id"
                field-name="button"
            >
                <Button
                    :backgroundColor="styleValues.brand"
                    :textColor="styleValues.background"
                    :href="dataValues.button.data.href"
                    :label="dataValues.button.data.label"
                />
            </EditableElement>
        </div>
        <div class="flex flex-1 justify-end">
            <DismissButton :accent-color="styleValues.brand" @dismiss="isVisible = false" />
        </div>
    </Background>
</template>
